import { success, successTint } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';
import { backgroundGreen, brandPrimary, brandPrimaryHover, gray, grayDark, titles } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';
import { StyleSheet } from 'aphrodite';

const pulseBorderKeyframes = {
	'0%': {
		boxShadow: `0 0 0 0 rgba(137, 201, 71, 0.7)`,
		transform: 'scale(0.95)',
	},
	'100%': {
		boxShadow: `0 0 0 0 rgba(137, 201, 71, 0)`,
		transform: 'scale(0.95)',
	},
	'70%': {
		boxShadow: `0 0 0 6px rgba(137, 201, 71, 0)`,
		transform: 'scale(1)',
	},
};

export const styleSheet = StyleSheet.create({
	bubble: {
		...aidaBaseStyles.flexCenter,
		animationDuration: '2s',
		animationIterationCount: 'infinite',
		animationName: [pulseBorderKeyframes],
		backgroundColor: success,
		borderRadius: '50%',
		bottom: -10,
		boxShadow: '0 0 0 0 rgba(137, 201, 71, 0)',
		color: 'white',
		fontSize: 10,
		height: 20,
		padding: 4,
		pointerEvents: 'none',
		position: 'absolute',
		right: -10,
		transform: 'scale(1)',
		transition: 'outline',
		width: 20,
	},
	clientsNearMeContainer: {
		...aidaBaseStyles.flexHorizontalCenter,
		maxWidth: 90,
		...CssSelectors.allChildren(
			{
				color: brandPrimaryHover,
				flexBasis: 50,
				flexGrow: 0,
				flexShrink: 0,
				fontSize: '12px',
				marginRight: 10,
			},
			':first-child'
		),
	},
	customerCard: {
		borderBottom: `1px solid ${gray}`,
		paddingBottom: 8,
		paddingTop: 8,
		':last-child': {
			borderBottom: 'none',
		},
	},
	customerIndustry: {
		backgroundColor: backgroundGreen,
		borderRadius: 8,
		color: brandPrimary,
		fontSize: 11,
		paddingBottom: 1,
		paddingLeft: 6,
		paddingRight: 6,
		paddingTop: 1,
	},
	customerLocation: {
		color: grayDark,
		fontSize: 12,
		marginTop: 2,
	},
	customerMeta: {
		alignItems: 'center',
		display: 'flex',
		gap: 6,
		marginTop: 4,
	},
	customerName: {
		color: titles,
		fontSize: 14,
		fontWeight: 600,
	},
	customerYears: {
		color: brandPrimaryHover,
		fontSize: 11,
	},
	customersList: {
		'::-webkit-scrollbar': {
			background: successTint,
			width: 5,
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: gray,
			borderRadius: 6,
			padding: '0',
		},
		maxHeight: 240,
		overflowY: 'auto',
	},
	customersColumn: {
		borderLeft: `1px solid ${gray}`,
		flex: 1,
		minWidth: 0,
		paddingLeft: 16,
	},
	customersSectionHeader: {
		color: brandPrimaryHover,
		fontSize: 12,
		letterSpacing: 1.1,
		marginBottom: 4,
		textTransform: 'uppercase',
	},
	globe: {
		...aidaBaseStyles.flexCenter,
		position: 'relative',
	},
	groupingsColumn: {
		flexShrink: 0,
		paddingRight: 16,
	},
	groupingsList: {
		'::-webkit-scrollbar': {
			background: successTint,
			width: 5,
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: gray,
			borderRadius: 6,
			padding: '0',
		},
		marginTop: 14,
		...CssSelectors.allChildren(
			{
				color: titles,
				fontSize: 14,
			},
			'div'
		),
		maxHeight: 200,
		overflowY: 'auto',
	},
	popoverContainer: {
		background: successTint,
		borderRadius: 10,
		display: 'flex',
		flexDirection: 'row',
		marginLeft: 20,
		maxWidth: 520,
		minWidth: 380,
		padding: 20,
		transform: 'translate3d(0, -50%, 0)',
	},
	totalClients: {
		color: brandPrimaryHover,
		fontSize: 14,
		letterSpacing: 1.1,
		textTransform: 'uppercase',
	},
});
